module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz6.d4c40cc6.mp3";